import app from "/src/app/app.module";


app.controller('dashboard-selection',
    function ($scope, msgBusActions, msgBus, $filter) {

        $scope.newItems = [
            {
                label: $filter('translate')('USER_RESPONDS'),
                description: $filter("translate")('USER_RESPONDS_DESC'),
                icon: "glyphicon glyphicon-user",
                id: 'UserResponseDashboard'
            },
            {
                label: $filter('translate')('JOB_TYPE_FILTER'),
                description: $filter("translate")('JOB_TYPE_FILTER_DESC'),
                icon: "glyphicon glyphicon-filter",
                id: 'JobTypeFilteredDashboard'
            },
            {
                label: $filter('translate')('BUSY_PERIODS'),
                description: $filter("translate")('BUSY_PERIODS_DESC'),
                icon: "glyphicon glyphicon-fire",
                id: 'BusyPeriodsDashboard'
            },
            {
                label: $filter('translate')('FINANCIAL_DASHBOARD'),
                description: $filter("translate")('FINANCIAL_DASHBOARD_DESC'),
                icon: "glyphicon glyphicon-euro",
                id: 'FinancialDashboard'
            },
            {
                label: $filter('translate')('PRODUCT_DASHBOARD'),
                description: $filter("translate")('PRODUCT_DASHBOARD_DESC'),
                icon: "glyphicon glyphicon-shopping-cart",
                id: 'ProductDashboard'
            }
        ];

        //msgBus.onMsg('show.wizard.page', function (sender, msg) {
        //    $scope.openWizard(msg);
        //}, $scope);


        $scope.openDashboard = function (newItem) {
            //var win = window.open('#/create/' + newItem.id, '_blank');
            //win.focus();
            msgBus.emitMsg(msgBusActions.shellOpenTabByType, {
                type: 'dashboard-grid', id: newItem.id, icon: newItem.icon
            });
        };
    }
);